import React from 'react';
type PageHeaderProps = {
  eyebrow: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
};
export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-106" data-mp="3rdkiiukxxs06">
      <div data-id="element-107" data-mp="3mf9dqy9i67ot">
        <p className="font-mono text-xs uppercase tracking-widest text-[#9b8cf0]" data-id="element-108" data-mp="3mgkcgjo3cp92">{eyebrow}</p>
        <h1 className="mt-3 text-3xl font-medium tracking-tight md:text-4xl" data-id="element-109" data-mp="2yqztw1vunu0b">{title}</h1>
        {description && <p className="mt-3 max-w-xl text-muted-foreground" data-id="element-110" data-mp="2ts6ge9gkc305">{description}</p>}
      </div>
      {actions}
    </div>;
}